import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import styled from 'styled-components';
import { variant } from 'styled-system';
import { get } from '../../styles/constant';
const ArrowBorder = variant({
  prop: 'placement',
  variants: {
    top: {
      borderTop: get('space.0'),
      borderLeft: get('space.0')
    },
    bottom: {
      borderBottom: get('space.0'),
      borderRight: get('space.0')
    },
    left: {
      borderBottom: get('space.0'),
      borderLeft: get('space.0')
    },
    right: {
      borderTop: get('space.0'),
      borderRight: get('space.0')
    }
  }
});
const variants = {
  ArrowBorder
};
const PopoverContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: auto;\n  font-size: ", ";\n  line-height: ", ";\n  box-sizing: border-box;\n"])), props => props.fit === 'small' ? get('space.14') : get('space.16'), props => props.fit === 'small' ? get('space.20') : get('space.24'));
const PopoverContentWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  max-width: calc(100vw - 10px);\n  width: max-content;\n  z-index: 99999;\n  display: block;\n  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 4%), 0px 1px 18px 0px rgb(0 0 0 / 3%),\n    0px 6px 10px 0px rgb(0 0 0 / 3%);\n  border: 1px solid rgb(207, 207, 207);\n  border-radius: 4px;\n"])), props => props.top ? "".concat(props.top, "px") : get('space.0'), props => props.left ? "".concat(props.left, "px") : get('space.0'));
const PopoverContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  overflow: auto;\n  color: rgb(20, 20, 20);\n  background: rgb(255, 255, 255);\n  border-radius: 4px;\n"])));
const Arrow = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border: 1px solid rgb(207, 207, 207);\n  background: rgb(255, 255, 255);\n  top: ", ";\n  left: ", ";\n  height: ", ";\n  width: ", ";\n  position: absolute;\n  transform: rotate(45deg);\n  z-index: -1;\n  ", "\n  ", "\n"])), props => props.top ? "".concat(props.top, "px") : 'unset', props => props.left ? "".concat(props.left, "px") : 'unset', props => props.fit === 'small' ? '7px' : props.fit === 'medium' ? '9px' : '11px', props => props.fit === 'small' ? '7px' : props.fit === 'medium' ? '9px' : '11px', variants.ArrowBorder, props => props.staticSide && {
  [props.staticSide]: props.fit === 'small' ? '-3px' : props.fit === 'medium' ? '-4px' : '-5px'
});
const Components = {
  PopoverContainer,
  PopoverContentWrapper,
  PopoverContent,
  Arrow
};
export { Components };